export enum CategoryEnum {
  "Technical" = 1,
  "Billing" = 2,
  "General" = 3,
  "Payment" = 4,
}